import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.177 40.842v-7.974h1.462a4.43 4.43 0 0 1 1.897.426l13.553 6.42a2.659 2.659 0 0 0 3.782-2.127c.38-3.667.57-8.781.57-15.352 0-6.57-.19-11.685-.57-15.351a2.656 2.656 0 0 0-3.782-2.128l-13.553 6.42a4.43 4.43 0 0 1-1.897.427h-5.88a9.746 9.746 0 0 0-9.742 9.467A58.96 58.96 0 0 0 6 22.229c.004.518.01.904.017 1.172a9.739 9.739 0 0 0 4.513 7.946l2.368 9.896a2.658 2.658 0 0 0 2.628 2.257h1.992a2.658 2.658 0 0 0 2.659-2.658Z",
    fill: "currentColor"
  }));
};

var SvgFeedback = styled(SvgComponent).withConfig({
  displayName: "Feedback__SvgFeedback",
  componentId: "sc-1lq1iv-0"
})(["", " ", ""], size, color);
export default SvgFeedback;